import { render, staticRenderFns } from "./question.vue?vue&type=template&id=a9863db8&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=a9863db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9863db8",
  null
  
)

export default component.exports